import { render, staticRenderFns } from "./NewProspect.vue?vue&type=template&id=553f838b&scoped=true&"
import script from "./NewProspect.vue?vue&type=script&lang=ts&"
export * from "./NewProspect.vue?vue&type=script&lang=ts&"
import style0 from "./NewProspect.vue?vue&type=style&index=0&id=553f838b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553f838b",
  null
  
)

export default component.exports